import { NavLink } from "react-router-dom";
import "../../Styles/General & MultiUse/LoginCheckpoint.css";
import ReactDOM from "react-dom";
import { useContext, useEffect } from "react";
import { ZGAContext } from "../../ZGAContext";

const LoginCheckpoint = () => {
  const { currentModal, closeModal } = useContext(ZGAContext);

  // const location = useLocation();

  // useEffect(() => {
  //   // Close modal when the location changes, indicating a "back" action
  //   if (currentModal === "loginCheckpoint") {
  //     closeModal();
  //   }
  // }, [location, currentModal, closeModal]);

  useEffect(() => {
    const handlePopState = () => {
      if (currentModal === "loginCheckpoint") {
        closeModal();
      }
    };
    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [currentModal, closeModal])

  if (currentModal !== "loginCheckpoint") return null;

  return ReactDOM.createPortal(
    <>
      <div className="backdrop" onClick={closeModal}></div>
      <div className="loginCheckpoint">
        <span>Login to proceed:</span>
        <NavLink to="/auth/login" onClick={closeModal}><button>Login</button></NavLink>
        <button onClick={closeModal}>Cancel</button>
      </div>
    </>,
    document.getElementById("modal-root")
  );
};

export default LoginCheckpoint;
